/* istanbul ignore file */
export class LogicStyledGridRowCellDictionary {
    [columnId: string]: string;
    rowStyleClass: string;
}
